import { getErrorCode, getRecordsList } from '@/app/core/composable/general'

export function notificationError(
  error: any,
  module: string,
  t: Function,
  notifications: any,
  loading: { value: boolean }
) {
  let title: any = 'Error'
  let text: any = error.message
  if (error.response && error.response.data) {
    const code = getErrorCode(error.response.data?.code)
    const records = getRecordsList(error.response.data?.params?.records)
    if (t('error.titles.' + code).includes(code)) {
      title = 'Error'
      text =
        code === 'bad-request'
          ? `${t('error.messages.bad-request')} '${
              error.response.data.message
            }'`
          : error.response.data.message
    } else {
      title = t('error.titles.' + code)
      text = t('error.messages.' + code, {
        entity: error?.response?.data?.params?.entity?.includes('pg_')
          ? error?.response?.data?.params?.entity.substring(3)
          : error?.response?.data?.params?.entity,
        entityName: t(module + '.list.title', 2),
        field: t('fields.' + error.response.data?.params?.field),
        value: error.response.data?.params?.value,
        sublist: t('sublist.' + error.response.data?.params?.sublist),
        entityId: error.response.data?.params?.entityId,
        message: error.response.data?.params?.message,
        depends: error.response.data?.params?.depends,
        strict: error.response.data?.params?.strict
          ? t('error.messages.enabled-error-text')
          : '',
        percentage: error.response.data?.params?.percentage,
        employees: error.response.data?.params?.employees,
        appliesFrom: error.response.data?.params?.appliesFrom,
        resource: error.response.data?.params?.resource,
        concept: error.response.data?.params?.concept,
        status: error.response.data?.params?.status,
        startDate: error.response.data?.params?.startDate,
        closeDate: error.response.data?.params?.closeDate,
        enable: error.response.data?.params?.enable
          ? t('error.messages.enabled-error-text')
          : '',
        id: error.response.data?.params?.id,
        records
      })
    }
  }
  notifications.addNotification({
    title,
    text,
    type: 'error',
    time: 10000
  })
  loading.value = false
}
